import {
  Fire, Barbell, Handshake, Smiley, SmileyMeh, Trash
} from '@phosphor-icons/react';

const MOOD_LABELS = { 1: 'Terrible', 2: 'Bad', 3: 'Okay', 4: 'Good', 5: 'Great' };

export default function ActiveBuddyCard({ buddyData, onRemove }) {
  return (
    <div className="tactical-card p-6 mb-6 border-[#34C759]/20" data-testid="active-buddy-card">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-3">
          <div className="w-14 h-14 bg-[#34C759]/10 border border-[#34C759]/30 flex items-center justify-center">
            <Handshake weight="bold" className="w-7 h-7 text-[#34C759]" />
          </div>
          <div>
            <div className="label-tactical text-[#34C759] mb-0.5">Your Buddy</div>
            <h3 className="text-2xl font-bold tracking-tight">{buddyData.buddy.name}</h3>
            <span className="text-xs text-[#71717A] uppercase">{buddyData.buddy.fitness_level}</span>
          </div>
        </div>
        <button onClick={onRemove} className="p-2 text-[#71717A] hover:text-[#FF3B30] transition-colors" data-testid="remove-buddy">
          <Trash weight="bold" className="w-5 h-5" />
        </button>
      </div>

      <div className="grid grid-cols-3 gap-3">
        <div className="bg-[#1C1C1E] border border-white/5 p-4 text-center">
          <Fire weight="fill" className="w-6 h-6 text-[#FF3B30] mx-auto mb-1" />
          <div className="text-2xl font-black font-['Barlow_Condensed']">{buddyData.buddy_stats?.streak || 0}</div>
          <div className="text-[10px] uppercase tracking-wider text-[#71717A]">Streak</div>
        </div>
        <div className="bg-[#1C1C1E] border border-white/5 p-4 text-center">
          <Barbell weight="bold" className="w-6 h-6 text-[#007AFF] mx-auto mb-1" />
          <div className="text-2xl font-black font-['Barlow_Condensed']">{buddyData.buddy_stats?.total_workouts || 0}</div>
          <div className="text-[10px] uppercase tracking-wider text-[#71717A]">Workouts</div>
        </div>
        <div className="bg-[#1C1C1E] border border-white/5 p-4 text-center">
          {buddyData.buddy_stats?.today_mood ? (
            <>
              <Smiley weight="fill" className="w-6 h-6 text-[#34C759] mx-auto mb-1" />
              <div className="text-sm font-bold">{MOOD_LABELS[buddyData.buddy_stats.today_mood] || 'N/A'}</div>
            </>
          ) : (
            <>
              <SmileyMeh weight="regular" className="w-6 h-6 text-[#71717A] mx-auto mb-1" />
              <div className="text-sm text-[#71717A]">Not logged</div>
            </>
          )}
          <div className="text-[10px] uppercase tracking-wider text-[#71717A]">Today's Mood</div>
        </div>
      </div>

      {buddyData.buddy.goals?.length > 0 && (
        <div className="mt-4 flex flex-wrap gap-1">
          {buddyData.buddy.goals.map(g => (
            <span key={g} className="px-2 py-0.5 text-xs bg-[#007AFF]/10 text-[#007AFF] border border-[#007AFF]/20 uppercase font-bold">
              {g.replace('_', ' ')}
            </span>
          ))}
        </div>
      )}
    </div>
  );
}
